import { useState } from 'react';
import I18njs from 'i18n-js';

import Button from 'carbon-react/lib/components/button';
import Form from 'carbon-react/lib/components/form';
import Loader from 'carbon-react/lib/components/loader';
import Message from 'carbon-react/lib/components/message';
import Textbox from 'carbon-react/lib/components/textbox';

import Translate from '../../components/Translate/Translate';

const LoginForm = ({ company, error, handleSubmit, history, loading, password, setCompany, setPassword, setUsername, username }) => {
  const [showPassword, setShowPassword] = useState(false);

  const LoginButtonDisabled = !company || !username || !password;

  const ErrorMsg = (typeof error === 'string' && error) || error?.message;

  return (
    <>
      <Form
        cancel={false}
        saveButton={
          <Button as="primary" className="login-button" disabled={LoginButtonDisabled} key="login" type="submit">
            {loading ? <Loader isInsideButton /> : <Translate scope="auth.LogIn" />}
          </Button>
        }
        onSubmit={handleSubmit}
        showSummary={false}
      >
        <div className="title">
          <Translate scope="auth.LogIn" />
        </div>
        <Textbox
          id="company"
          label={I18njs.t('auth.IntacctCompanyID')}
          name="company"
          onChange={(e) => {
            setCompany(e.target.value);
          }}
          value={company}
        />
        <Textbox
          id="userId"
          label={I18njs.t('auth.IntacctUserID')}
          name="userId"
          onChange={(e) => {
            setUsername(e.target.value);
          }}
          value={username}
        />
        <div className="password-wrapper fs-exclude">
          <Textbox
            id="password"
            label={I18njs.t('auth.Password')}
            name="password"
            onChange={(e) => setPassword(e.target.value)}
            type={showPassword ? 'text' : 'password'}
            value={password}
          >
            <Button buttonType="tertiary" onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? <Translate scope="auth.HIDE" /> : <Translate scope="auth.SHOW" />}
            </Button>
          </Textbox>
          <Button buttonType="tertiary" className="forgot-password" size="small" onClick={() => history.push('/forgot-password')}>
            <Translate scope="auth.Forgotpassword" />
          </Button>
        </div>
        {ErrorMsg && (
          <div className="error-wrapper">
            <Message variant="error">{ErrorMsg}</Message>
          </div>
        )}
      </Form>
    </>
  );
};

export default LoginForm;
